import { CUSTOM_HEADERS, CustomHeaderType } from './constants'
import { getDefaultTermHeader } from '../getDefaultTermHeader.js'
import { localizeCenterToCentre } from '../../../utils/localizeCenter.js'
import { MIN_CENTER_COUNT_THRESHOLD } from '../../center/constants.js'
import { isFacetPageType } from '../../useCases/pageTypeCheck'
import { PageType } from '@/types/models/PageType.model'

type GetTermHeaderParams = {
  pageType?: PageType
  title: string
  termTitle: string
  shouldDefaultRegionalize: boolean
  headerType: CustomHeaderType
  customTermHeader?: string
  centerCount?: number
}

const defaultParams = {} as GetTermHeaderParams

export const getTermHeader = ({
  pageType,
  title,
  termTitle,
  customTermHeader,
  shouldDefaultRegionalize = false,
  headerType,
  centerCount = 0
}: GetTermHeaderParams = defaultParams): string => {
  if (!pageType) {
    return ''
  }

  const defaultHeader = getDefaultTermHeader(
    pageType,
    isFacetPageType(pageType) ? termTitle : title
  )

  const headersForPageType = CUSTOM_HEADERS[headerType]

  if (!headersForPageType) {
    return ''
  }

  let customHeader = headersForPageType[pageType]
    ?.replace('@title', title)
    ?.replace('@customTermHeader', customTermHeader || defaultHeader)

  if (!customHeader) {
    return ''
  }

  if (
    headerType === CustomHeaderType.CENTER_FEED &&
    centerCount > MIN_CENTER_COUNT_THRESHOLD
  ) {
    customHeader = `${centerCount} ${customHeader}`
  }

  return shouldDefaultRegionalize
    ? localizeCenterToCentre(customHeader)
    : customHeader
}
